import {Component} from '@angular/core';
import {GnTableComponent} from '../../table/table.component';
import {GnTableColumn} from '../TableColumn';
import {GnTableColumnConfig} from '../TableColumnConfig';

@Component({
  selector: 'gn-json-table-edit-column',
  templateUrl: './edit-column.component.html',
  styleUrls: ['./edit-column.component.css'],
})
@GnTableColumn('editableColumn')
export class GnEditColumnComponent {

  row: any;

  displayColumn: GnTableColumnConfig;
  editColumn: GnTableColumnConfig;

  constructor(public table: GnTableComponent) {
  }

}
